import { render, staticRenderFns } from "./EditRegulation.vue?vue&type=template&id=40dc1d7f"
import script from "./EditRegulation.vue?vue&type=script&lang=js"
export * from "./EditRegulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports